import React from "react";
import { SignIn, RequireNewPassword, ForgotPassword } from "aws-amplify-react";
import config from "./aws-exports";
import { Login } from "./components/views/auth/login";
import { CustomRequireNewPassword } from "./components/views/auth/RequireNewPassword";
import { CustomForgotPassword } from "./components/views/auth/ForgotPassword";
import App from "./App";
import { Authenticator } from "aws-amplify-react";

// Import the public components directly
import ClaimPage from "./components/views/claim/ClaimPage";
import ClaimReferralPage from "./components/views/claim/ReferralClaimForm";
import PublicReferralForm from "./components/views/referrals/PublicReferralForm";
import DealerSignup from "./components/views/auth/DealerSignup";
import DealerWelcome from "./components/views/auth/DealerWelcome";
import EstimateChatbot from "./components/views/estimates/EstimateChatbot";
import { BrowserRouter, Route, Switch } from "react-router-dom";

class AppWithAuth extends React.Component {
  // Check if current path is a public route (no auth required)
  isPublicRoute = () => {
    const path = window.location.pathname;
    const publicPaths = ['/claim', '/referralclaim', '/public/referral', '/signup/dealer', '/welcome', '/estimate'];
    return publicPaths.some(publicPath => path.startsWith(publicPath));
  };

  render() {
    // If it's a public route, render directly without authentication
    if (this.isPublicRoute()) {
      return (
        <div className="App">
          <BrowserRouter>
            <Switch>
              <Route path="/claim" component={ClaimPage} />
              <Route path="/referralclaim" component={ClaimReferralPage} />
              <Route path="/public/referral" component={PublicReferralForm} />
              <Route path="/signup/dealer" component={DealerSignup} />
              <Route path="/welcome" component={DealerWelcome} />
              <Route path="/estimate" component={EstimateChatbot} />
            </Switch>
          </BrowserRouter>
        </div>
      );
    }

    // For /login and all other routes, show Authenticator
    return (
      <Authenticator hide={[SignIn, RequireNewPassword, ForgotPassword]} amplifyConfig={config}>
        <Login />
        <CustomRequireNewPassword />
        <CustomForgotPassword />
        <App />
      </Authenticator>
    );
  }
}

export default AppWithAuth;